<template>
  <div class="">
    <b-overlay :show="apiLoading" spinner-variant="primary" blur=".3" opacity=".75" rounded="sm" class="p-3">
      <template v-if="enableSearch">
        <div class="mb-5">
          <search-box @search="handleParamsChanges([{ k: 'search', v: $event }])" class="p-0" />
        </div>
      </template>

      <order-card
        v-for="order in orders"
        :key="order.id"
        :order="order"
        class="mb-1"
        :isDashboard="isDashboard"
        @reorder="reOrder"
        @print="printInvoice"
      />

      <template v-if="enablePagination">
        <!-- Table mode pagination -->
        <pagination-controls
          v-if="pagination.options.table"
          :total-records="pagination.total"
          :params="params"
          :pagination-options="pagination.options"
          :moving-page="pagination.movingPage"
          @get-table-data="handleParamsChanges([{ k: 'page', v: $event }])"
        />
        <!-- General mode pagination -->
        <v-pagination
          v-else-if="pagination.options.table === false && pagination.total > params.per_page"
          :total-page="pagination.lastPage"
          :current-page="pagination.movingPage"
          @page-changed="handleParamsChanges([{ k: 'page', v: $event }])"
        >
        </v-pagination>
      </template>
    </b-overlay>
    <Invoice ref="Invoice" v-show="false" :order="selectedOrder" :isDashboard="isDashboard" />
  </div>
</template>

<script>
import ApiMixin from "@core/mixin/ApiMixin"
import SearchBox from "@core/components/SearchBox"
import OrderCard from "@core/components/orders/OrderCard"
import PaginationControls from "@core/components/PaginationControls"
import Invoice from "@core/components/orders/invoice/Invoice.vue"
import { currencyFormat } from "@core/helpers/configHelper"

const API_URL_PREFIX = "api"

export default {
  name: "AccountOrders",
  mixins: [ApiMixin],
  props: {
    endpoint: { type: String, required: false, default: "my_orders" },
    customersEndpoint: { type: String, required: false, default: "api/orders/customer?all_shopify_orders=1&customer_id=" },
    queryParams: { type: Object, required: false, default: () => ({ page: 1, per_page: 10, search: undefined }) },
    enableSearch: { type: Boolean, required: false, default: true },
    enablePagination: { type: Boolean, required: false, default: true },
    paginationOptions: {
      type: Object,
      required: false,
      default: () => ({ table: true, perPageDropdown: [10, 20, 50, 100] })
    },
    updateCartAfterReordering: { type: Boolean, required: false, default: false },
    customerId: {type: String},
    isDashboard: {type:Boolean, default: true}
  },
  components: {
    Invoice,
    SearchBox,
    OrderCard,
    PaginationControls
  },
  data() {
    return {
      isModalOpen: false,
      selectedOrder: null,
      orders: [],
      params: this.queryParams,
      pagination: {
        options: this.paginationOptions,
        movingPage: this.queryParams.page,
        lastPage: this.queryParams.page,
        total: 0
      }
    }
  },
  watch: {
    "params.page": {
      handler(newVal) {
        this.pagination.movingPage = newVal
      }
    }
  },
  methods: {
    getData() {
      let apiUrl = `${this.endpoint}`
      if (this.customerId)
        apiUrl = `${this.customersEndpoint}` + this.customerId
      const apiParams = { ...this.params }

      this.get(apiUrl, apiParams)
        .then(({ data, total, last_page }) => {
          this.orders = data
          this.pagination.total = total
          this.pagination.lastPage = last_page
        })
        .catch(err => {
          console.error(err)
        })
    },
    reOrder({ id }) {
      const apiUrl = `re-order/${id}`

      this.post(apiUrl)
        .then(cart => {
          // use updateCartAfterReordering as true only when you use this component on storefront
          // because only the $store inside storefront has update cart functionality
          if (this.updateCartAfterReordering) {
            this.$store.updateCart(cart)
          }
          window.location.href = '/cart';
          this.getData()
        })
        .catch(err => {
          console.error(err)
        })
    },
    async printInvoice(order) {
      this.isModalOpen = true
      const mapTable = products => {
        const temp = []
        products.forEach(item => {
          if (item.product) {
            temp.push({
              image: item.product.media ? (item.product.media.length ? item.product.media.map(el => el.id) : []) : [],
              imageThumbnail: item.product.media,
              name: item.product.name,
              sku: item.product.sku,
              price: currencyFormat(item.unit_price.amount),
              discount_price: currencyFormat(item.discount_price),
              is_daily_deal: item.is_daily_deal,
              qty: item.qty,
              slug: item.product.slug,
              // total: currencyFormat(item.total.amount),
              total: currencyFormat(item.line_total.amount)
            })
          }
          else {
            temp.push({
              image: [],
              imageThumbnail: [],
              name: item.product_name,
              sku: item.product_sku,
              price: currencyFormat(item.unit_price.amount),
              discount_price: currencyFormat(item.discount_price),
              is_daily_deal: item.is_daily_deal,
              qty: item.qty,
              slug: "",
              // total: currencyFormat(item.total.amount),
              total: currencyFormat(item.line_total.amount)
            })
          }

        })
        console.log("TEMP: ", temp)
        return temp
      }
      order["productsTable"] = []
      order["productsTable"] = mapTable(order.order_products)
      this.selectedOrder = order
      await this.$nextTick()
      await this.$refs.Invoice.printInvoice()
    },
    handleParamsChanges(changes = [], callApiAfterUpdate = true) {
      changes.forEach(({ k, v }) => {
        this.params[k] = v
      })

      if (callApiAfterUpdate) this.getData()
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
